import BookSlotForm from "../BookSlotForm";

import Typography from "@/foundation/Typography/V2";

import { classNameGenerator, clsx } from "@/utils";

import { useAppSelector, useAppDispatch } from "@/hooks";

import styles from "./BookSpotForm.module.scss";
import TncStrip from "../TermsAndConditionStrip";


interface BookSpotFormProps {
  standalone?: boolean;
}

const BookSpotForm: React.FC<BookSpotFormProps> = ({ standalone }) => {
  const cls = classNameGenerator(styles);

  const { data } = useAppSelector((state) => state.bootCamp);

  const prefix = "Book your spot!";
  const title = `for ${data?.packData?.title}`;


  return (
    <div
      className={clsx(cls("bookSpotForm"), standalone ? cls("standalone") : "")}
    >
      <div className={cls("BookSpotFormWrapper")}>
        <div className={cls("header")}>
          <Typography
            variant="paragraph1"
            className={cls("prefix")}
            dangerouslySetInnerHTML={{ __html: prefix }}
          />
          <Typography
            variant="heading2"
            className={cls("title")}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        </div>
        <BookSlotForm
          showModal={{
            packageData: data?.packData,
          }}
        />
      </div>
      <TncStrip/>
    </div>
  );
};

export default BookSpotForm;
